import * as Sentry from "@sentry/react";
import { getConsent } from "@/components/consent/CookieBanner";

/**
 * Sentry initialiseres KUN hvis brugeren har givet samtykke til statistik.
 * Ved samtykke-ændring (event 'consent:change') initialiseres eller lukkes Sentry.
 */
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) {
    console.warn("Sentry DSN not configured - error tracking disabled");
    return;
  }

  const start = () => {
    if ((Sentry.getClient?.() as unknown) !== undefined) return; // already initialised
    bootSentry(dsn);
  };
  const stop = () => {
    try { Sentry.close(0); } catch { /* noop */ }
  };

  if (getConsent()?.statistics) start();

  if (typeof window !== 'undefined') {
    window.addEventListener('consent:change', (e: Event) => {
      const detail = (e as CustomEvent<{ statistics?: boolean }>).detail;
      if (detail?.statistics) start(); else stop();
    });
  }
}

function bootSentry(dsn: string) {


  Sentry.init({
    dsn,
    
    // Performance Monitoring
    tracesSampleRate: 1.0,
    
    // Set the environment
    environment: import.meta.env.MODE,
    
    // Release tracking
    release: `bilbase-danmark@${import.meta.env.VITE_APP_VERSION || "1.0.0"}`,
    
    // Browser tracing integration
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    
    // Filter out noisy errors
    ignoreErrors: [
      "top.GLOBALS",
      "NetworkError",
      "Failed to fetch",
      "Load failed",
      /extensions\//i,
      /^chrome:\/\//i,
    ],
    
    // Before sending, filter dev errors
    beforeSend(event) {
      if (import.meta.env.DEV && !import.meta.env.VITE_SENTRY_DEV) {
        console.log("Sentry event (dev mode):", event);
        return null;
      }
      return event;
    },
  });
}

// Export Sentry for manual error reporting
export { Sentry };
